import {PipelineSelectorProps, pipelinesSelector, useGetAllPipelinesQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BasePipelineMultiSelect, BasePipelineMultiSelectProps} from "./BasePipelineMultiSelect";

export type PipelineMultiSelectProps = Omit<BasePipelineMultiSelectProps, "entities" | "loading"> & {
  selector?: PipelineSelectorProps
}

export const PipelineMultiSelect = (props: PipelineMultiSelectProps) => {
  const {selector, ...rest} = props;

  const selectPipelines = useMemo(() => {
    return pipelinesSelector()
  }, [])

  const {pipelines, isLoading} = useGetAllPipelinesQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      pipelines: selectPipelines(result, selector),
      isLoading: result.isLoading,
    })
  });

  return <BasePipelineMultiSelect entities={pipelines} loading={isLoading} {...rest} />;
};
